import { useContext } from 'react';

import { Button, Icon, IconButton } from '@atom/mui';
import { CloseIcon, EditIcon } from '@atom/mui/icons';
import { SUB_SOURCE_LABEL } from '@atom/utilities/policyUtilities';

import PolicyModalContext from './PolicyModalContext';

import classes from './policyModals.module.css';

const PolicyGenericGrantsSelection = () => {
  const { state, updateState } = useContext(PolicyModalContext);

  const { grantType, grants, loadingExistingPolicies } = state;

  return (
    <div className={classes.inputContainer}>
      <div className={classes.label}>{SUB_SOURCE_LABEL[grantType]}</div>
      {grants.length ? (
        <div className={classes.tile}>
          {grants.map(({ name }) => name).join(', ')}
          <div className={classes.tile}>
            <IconButton
              size="small"
              onClick={() => updateState({ view: grantType })}
              disabled={loadingExistingPolicies}
              data-cy="roleDetailPolicyGrantEditButton"
            >
              <Icon icon={EditIcon} />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => updateState({ grants: [] })}
              disabled={loadingExistingPolicies}
              data-cy="roleDetailPolicyGrantClearButton"
            >
              <Icon icon={CloseIcon} />
            </IconButton>
          </div>
        </div>
      ) : (
        <Button
          size="small"
          color="primary"
          onClick={() => updateState({ view: grantType })}
          style={{ minWidth: 0, padding: 0 }}
          disabled={loadingExistingPolicies}
          data-cy="roleDetailPolicyGrantSelectButton"
        >
          Select
        </Button>
      )}
    </div>
  );
};

export default PolicyGenericGrantsSelection;
